import styled, { css } from 'styled-components';
import { fontFamily } from 'components/styles/_variables';
import { respondTo } from 'components/styles/_respondTo';

export const Wrapper = styled.div`
  display: flex;

  ${({ main = false }) =>
    main &&
    css`
      ${respondTo.mobile`
      width: 100%;
      justify-content: space-between;
    `}
    `}
`;

export const Item = styled.div`
  font-family: ${fontFamily.primary};
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.4;
  letter-spacing: normal;
  color: #ff7828;
  //margin-right: 3px;

  &:last-child {
    &:after {
      content: '';
    }
  }

  &:after {
    margin: 0 3px;
    content: '/';
  }
`;

export const Divider = styled.div``;
